import { useState } from 'react';
import styled from 'styled-components/macro';
import { WxText } from '../..';
import { PlacesResponse } from '../../../hooks/api/queries/usePlaces';
import { breakpoint } from '../../../styles/constants';

interface Props {
  placeholder: string;
  required?: boolean;
  setValue: (value: string) => void;
  value?: string;
  data?: PlacesResponse;
  setPlaceId?: (s: string) => void;
  readOnly?: boolean;
  type?: React.HTMLInputTypeAttribute;
  errors?: string[]
}

export const StringInput = ({
  placeholder,
  required = false,
  setValue,
  value = '',
  data,
  setPlaceId,
  readOnly = false,
  type = 'string',
  errors = []
}: Props) => {
  const [focus, setFocus] = useState(false);

  // const error = data
  //   ? data?.hits.length === 0 || data?.hits.length !== 1
  //   : false;
  return (
    <label onBlur={() => setFocus(false)}>
      <Input
        type={type}
        autoComplete="false"
        required={required}
        value={value}
        placeholder={`${placeholder}${required ? '*' : ''}`}
        onChange={(e) => setValue(e.target.value)}
        onInputCapture={() => setFocus(true)}
        onFocus={() => setFocus(true)}
        readOnly={readOnly}
        $error={!!errors.length}
        // $valid={valid}
      />

      {focus && data?.hits && data?.hits.length > 0 && (
        <DropDown>
          {data.hits.map((item, key) => (
            <div
              key={key}
              onBlur={() => setFocus(false)}
              onMouseDown={() => {
                setPlaceId?.(item.place_id);
                setValue(item.locale_names?.[0]);
                setFocus(false);
              }}
            >
              <WxText text={item.details} />
            </div>
          ))}
        </DropDown>
      )}
      {
        errors.map((error, key) => <Error key={key}>{error}</Error>)
      }
    </label>
  );
};

export const Input = styled.input<{
  $error?: boolean;
  $valid?: boolean;
  readOnly?: boolean;
}>`
  --border-color: ${({ $error, $valid, theme, readOnly }) =>
    $error
      ? theme.colors.red
      : $valid
      ? theme.colors.green
      : readOnly
      ? theme.colors.darkgray
      : theme.colors.white};

  width: 100%;
  background-color: transparent;
  color: ${({ theme, readOnly }) =>
    readOnly ? theme.colors.darkgray : theme.colors.white};
  outline: none;
  border: none;
  padding: 1rem;
  /* max-width:  */
  border-bottom: 1px solid var(--border-color);
  font-size: 0.75rem;
  @media (min-width: ${breakpoint}) {
    font-size: 0.85rem;
  }

  &:focus {
    background: unset;
    border-color: unset;
  }
`;

const DropDown = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  position: absolute;
  z-index: 1;
  width: 100%;
  padding-bottom: 1rem;
  display: flex;
  max-height: 8rem;
  overflow-y: scroll;
  flex-direction: column;
  > * {
    width: 100%;
    cursor: pointer;
    padding-block: 0.325rem;
    &:hover {
      background-color: black;
      p {
        color: white;
      }
    }

    p {
      margin-left: 0.625rem;
    }
  }
`;

const Error = styled.div`
  color: ${({ theme }) => theme.colors.red};
  font-size: 0.625rem;
  font-weight: 400;
  text-transform: uppercase;

  position: absolute;
  left: 1rem;
  bottom: -1.2rem;
`;
